module.exports = __webpack_public_path__ + "media/images/game/pages/logo_podnikavost-6a571d565b40a44a077ef7d1e4b24bab.png";